import { render, staticRenderFns } from "./PatientSummary.vue?vue&type=template&id=4cda061a&scoped=true&"
import script from "./PatientSummary.vue?vue&type=script&lang=js&"
export * from "./PatientSummary.vue?vue&type=script&lang=js&"
import style0 from "./PatientSummary.vue?vue&type=style&index=0&id=4cda061a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cda061a",
  null
  
)

export default component.exports